import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { Form, Input } from 'antd';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { GetProjectSuccessResponse } from '../../../../../types/api/project/get-project-success-response';
import { showLoadingAlertMessage } from '../../../../../../../utils/show-loading-alert-message/show-loading-alert-message';
import { networkCall } from '../../../../../../../utils/network-call/network-call';
import { showDefaultErrorMessages } from '../../../../../../../utils/show-default-error-message/show-default-error-messages';
import { AlertMessageState, clearAlertMessage, showAlertMessage } from '../../../../../../../redux/reducer/alert-message.reducer';
import { AlertMessages } from '../../../../../../../enums/alert-messages.enum';
import { DefaultErrorResponse } from '../../../../../../../types/api/error/default-error-response/default-error-respose.type';
import { ValidationErrorResponseData } from '../../../../../../../types/api/error/validation-error-response-data/validation-error-response-data.type.';
import { tranformAPIValidationErrorToAntDValidationMessage } from '../../../../../../../utils/validation/transform-api-validation-errors-to-antd-validation-messsages';
import { setSelectedMenuItemKeys } from '../../../../../../../redux/reducer/antd-layout-info.reducer';
import { CMSButton } from '../../../../../../../components/cms/button/cms-button.';
import { getImageUrl } from '../../../../../../../utils/image-helper/get-image-url';

export const CompanyAdminProjectEdit = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const loaderData: any = useLoaderData();
    const navigate = useNavigate();
    const [moduleChechboxes, setModuleChechboxes] = useState({
        workInstructionModule: {
            error: '',
            value: false
        },
        processEditorModule: {
            error: '',
            value: false
        },
        modelSpaceModule: {
            error: '',
            value: false
        },
        layerEditorModule: {
            error: '',
            value: false
        }
    });

    const handleCheckboxChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(moduleChechboxes));
        for (const prop in _moduleChechboxes) {
            _moduleChechboxes[prop as keyof typeof moduleChechboxes].error = '';
        }
        _moduleChechboxes[e.target.name as keyof typeof _moduleChechboxes].value = e.target.checked;
        setModuleChechboxes(_moduleChechboxes);
    };

    const handleFinish = async (values: any) => {
        if (moduleChechboxes.processEditorModule.value === true && moduleChechboxes.modelSpaceModule.value === false) {
            const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(moduleChechboxes));
            _moduleChechboxes.modelSpaceModule.error = 'A folyamatszerkesztő modulhoz a modelltér modul kiválasztása kötelező.'
            setModuleChechboxes(_moduleChechboxes);
            return;
        }

        if (moduleChechboxes.layerEditorModule.value === true && moduleChechboxes.modelSpaceModule.value === false) {
            const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(moduleChechboxes));
            _moduleChechboxes.modelSpaceModule.error = 'A rétegszerkesztő modulhoz a modelltér modul kiválasztása kötelező.'
            setModuleChechboxes(_moduleChechboxes);
            return;
        }

        showLoadingAlertMessage();

        const response = await networkCall(`/projects/${ loaderData.id }`, {
            method: 'PUT',
            body: {
                name: values.name,
                description: values.description,
                workInstructionModule: moduleChechboxes.workInstructionModule.value,
                processEditorModule: moduleChechboxes.processEditorModule.value,
                modelSpaceModule: moduleChechboxes.modelSpaceModule.value,
                layerEditorModule: moduleChechboxes.layerEditorModule.value
            }
        });

        const messageShowed = showDefaultErrorMessages(response);
        if(messageShowed) return;

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: AlertMessages.UnknownErrorTryAgain
        };

        if (response?.status === 200) {

            alertMessageState.alertMessageText = 'Mentés sikeres.';
            alertMessageState.alertMessageType = 'success';
            navigate(`/cms/company-admin/projects/${ loaderData.id }/modules`);

        } else if (response?.status === 400) {
            const res: AxiosResponse<DefaultErrorResponse> = response;

            switch (res.data.code) {

                case 1000:
                    const _res: AxiosResponse<DefaultErrorResponse<ValidationErrorResponseData[]>> = response;
                    alertMessageState.alertMessageText = 'Hibásan megadott beviteli mezők.';
                    const validationErrors = tranformAPIValidationErrorToAntDValidationMessage(_res.data.data!);
                    form.setFields(validationErrors);

                    const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(moduleChechboxes));
                    _res.data.data?.forEach(validationError => {
                        _moduleChechboxes[validationError.field as keyof typeof moduleChechboxes].error = validationError.errors.join(' ');
                    });
                    setModuleChechboxes(_moduleChechboxes);
                    break;

            }

        } else if (response?.status === 404) {
            const res: AxiosResponse<DefaultErrorResponse> = response;

            switch (res.data.code) {
                case 4000:
                    alertMessageState.alertMessageText = 'A projekt nem található.';
                    navigate('/cms/company-admin/projects');
                    break;
            }

        }

        dispatch(showAlertMessage(alertMessageState));

    }

    useEffect(() => {
        if(loaderData.getProjectResponse && loaderData.getProjectResponse?.status === 200) {
            const res: AxiosResponse<GetProjectSuccessResponse> = loaderData.getProjectResponse;
            form.setFieldValue('name', res.data.project.name);
            form.setFieldValue('description', res.data.project.description);
            setModuleChechboxes(prevState => {
                const _moduleChechboxes: typeof moduleChechboxes = JSON.parse(JSON.stringify(prevState));
                _moduleChechboxes.workInstructionModule.value = res.data.project.workInstructionModule;
                _moduleChechboxes.processEditorModule.value = res.data.project.processEditorModule;
                _moduleChechboxes.modelSpaceModule.value = res.data.project.modelSpaceModule;
                _moduleChechboxes.layerEditorModule.value = res.data.project.layerEditorModule;

                return _moduleChechboxes;
            });
            return;
        }
    }, [loaderData.getProjectResponse, form]);

    useEffect(() => {
        dispatch(setSelectedMenuItemKeys(['company-admin-projects']));
    }, [dispatch]);

    return (
        <>
            <div className="page-title">Projekt módosítása</div>
            <Form
                form={form}
                onFinish={handleFinish}
                layout='vertical'
            >

                <Form.Item
                    label='Projekt neve'
                    name='name'
                    rules={[{required: true, message: 'Név megadása kötelező!'}]}
                    className='mb-2'
                >
                    <Input className='box-shadow-4-4-8-0 border-0' />
                </Form.Item>

                <Form.Item
                    label='Leírás'
                    name='description'
                    rules={[{required: true, message: 'Leírás megadása kötelező!'}]}
                    className='mb-2'
                >
                    <Input.TextArea
                        className='box-shadow-4-4-8-0 border-0'
                        placeholder='Leírás'
                        autoSize={{ minRows: 5 }}
                    />
                </Form.Item>

                <div className='box-shadow-4-4-8-0 py-2 company-admin-project-add-module-checkboxes-container'>
                    
                    <strong>Modulok</strong>

                    <label className='cursor-pointer d-flex align-items-center gap-1 mt-2'>
                        <input
                            name='workInstructionModule'
                            type='checkbox'
                            className='cursor-pointer'
                            checked={moduleChechboxes.workInstructionModule.value}
                            onChange={handleCheckboxChange}
                        />
                        <span>Munkautasítás</span>
                    </label>

                    <div className='error'>{ moduleChechboxes.workInstructionModule.error }</div>

                    <label className='cursor-pointer d-flex align-items-center gap-1 mt-1'>
                        <input
                            name='processEditorModule'
                            type='checkbox'
                            className='cursor-pointer'
                            checked={moduleChechboxes.processEditorModule.value}
                            onChange={handleCheckboxChange}
                        />
                        <span>Folyamatszerkesztő</span>
                    </label>

                    <div className='error'>{ moduleChechboxes.processEditorModule.error }</div>

                    <label className='cursor-pointer d-flex align-items-center gap-1 mt-1'>
                        <input
                            name='modelSpaceModule'
                            type='checkbox'
                            className='cursor-pointer'
                            checked={moduleChechboxes.modelSpaceModule.value}
                            onChange={handleCheckboxChange}
                        />
                        <span>Modelltér</span>
                    </label>

                    <div className='error'>{ moduleChechboxes.modelSpaceModule.error }</div>

                    <label className='cursor-pointer d-flex align-items-center gap-1 mt-1'>
                        <input
                            name='layerEditorModule'
                            type='checkbox'
                            className='cursor-pointer'
                            checked={moduleChechboxes.layerEditorModule.value}
                            onChange={handleCheckboxChange}
                        />
                        <span>Rétegszerkesztő</span>
                    </label>

                    <div className='error'>{ moduleChechboxes.layerEditorModule.error }</div>
  
                </div>

                <Form.Item className='mt-4'>
                    <div className='d-flex justify-content-between'>
                        <Link to='/cms/company-admin/projects'>
                            <CMSButton text='Vissza' type='white' iconSrc={getImageUrl('back-icon.png')} />
                        </Link>
                        <CMSButton text='Mentés' iconSrc={getImageUrl('Save-icon.png')} htmlType='submit' />
                    </div>
                </Form.Item>
                        
            </Form>
        </>
    );
};